import { NG_VALIDATORS, UntypedFormControl, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appNumberValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: NumberValidatorDirective, multi: true }],
})
export class NumberValidatorDirective implements Validator {
    validate(field: UntypedFormControl) {
        if (field.value || field.value === 0) {
            // pattern ^[+-]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)*([0-9]?)$
            return this.isNumeric(field.value.toString())
                ? null
                : {
                      validateNumber: {
                          invalid: true,
                      },
                  };
        } else {
            return null;
        }
    }

    private isNumeric(value) {
        const testString = value.replace(/,/g, '.');
        return !isNaN(Number(testString)) && !isNaN(parseFloat(testString));
    }
}
